import type { ButtonSizes } from "../../Button/Button/types";
import type { ContentSize } from "../../Content/Content/types";
import type { IllustrationSizes } from "../../Illustration/types";
import type { VibeContexts } from "../types";

export const ILLUSTRATION_SIZE_BY_VIBE_CONTEXT: Record<
    Exclude<VibeContexts, "custom">,
    IllustrationSizes
> = {
    page: "112",
    island: "96",
    float: "96",
} as const;

export const TITLE_SIZE_BY_VIBE_CONTEXT: Record<
    Exclude<VibeContexts, "custom">,
    ContentSize
> = {
    page: "27b",
    island: "21b",
    float: "17b",
} as const;

export const SUBTITLE_SIZE_BY_VIBE_CONTEXT: Record<
    Exclude<VibeContexts, "custom">,
    ContentSize
> = {
    page: "17",
    island: "17",
    float: "15",
} as const;

export const BUTTON_SIZE_BY_VIBE_CONTEXT: Record<
    Exclude<VibeContexts, "custom">,
    ButtonSizes
> = {
    page: "56",
    island: "36",
    float: "36",
} as const;
